import { useState } from "react";
import { AudioLines, Pause, Play } from "lucide-react";
import { api } from "../lib/api";
import { useAudio } from "../context/AudioContext";

export default function NarrateButton({ piece }) {
  const { current, playing, toggle } = useAudio();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const slug = `narration-${piece.slug}`;
  const on = current?.slug === slug && playing;

  const go = async () => {
    if (current?.slug === slug) return toggle();
    setBusy(true); setErr("");
    try {
      const { data } = await api.post(`/narration/${piece.slug}`, null, { timeout: 240000 });
      toggle({ slug, title: piece.title, version: "Read aloud", kind: "Narration", audio: `${process.env.REACT_APP_BACKEND_URL}${data.url}`, cover: piece.image || "/media/ink.jpg", duration: 0 });
    } catch (e) {
      setErr(e?.response?.data?.detail || "The voice broke. Try again.");
    }
    setBusy(false);
  };

  return (
    <div data-testid="narrate-panel">
      <button onClick={go} disabled={busy} className="group w-full flex items-center gap-4 border border-[var(--line)] p-4 hover:border-[var(--bone)] transition-colors text-left disabled:opacity-70" data-testid="narrate-button">
        <span className={`w-12 h-12 shrink-0 rounded-full flex items-center justify-center border ${on ? "bg-[var(--signal)] border-[var(--signal)]" : "border-[var(--bone)]"}`}>
          {busy ? <AudioLines size={16} className="animate-pulse" /> : on ? <Pause size={16} /> : <Play size={16} className="ml-0.5" />}
        </span>
        <span>
          <span className="block f-mono text-[11px] text-[var(--ash)] uppercase">Read aloud &middot; AI voice</span>
          <span className="block f-display font-bold uppercase text-lg leading-tight">{busy ? "Finding the voice\u2026" : "Listen to this piece"}</span>
        </span>
      </button>
      {busy && <p className="f-mono text-[11px] text-[var(--ash)] mt-2">First listen takes up to a minute.</p>}
      {err && <p className="text-sm text-[var(--signal)] mt-2">{err}</p>}
    </div>
  );
}
